import * as React from 'react';
import { ArticleTitle } from '../components/titles/ArticleTitle';
import { useTheme } from '../../theming/useTheme';
import { AuthorsList } from '../articleComponents/author/AuthorsList';

export const componentConfigurationKey = 'ampArticleTitleWrapper';

export interface AMPArticleTitleWrapperDataProps {
    title: string;
    by: string;
    updatedText: string;
    authors: AuthorsList | null;
    updatedAt: string;
    updatedAtDate: string;
    updatedAtISO: string;
    showUpdatedAt: boolean;
    createdAt: string;
    createdAtDate: string;
    createdAtISO: string;
}

export interface AMPArticleTitleWrapperThemeProps {
    showOnlyDate: boolean;
}

export const AMPArticleTitleWrapper: React.FunctionComponent<AMPArticleTitleWrapperDataProps> = props => {
  const { title, by, updatedText, updatedAt, updatedAtDate, updatedAtISO, showUpdatedAt, createdAt, createdAtDate, createdAtISO, children, authors } = props;
  const themeProps = useTheme<AMPArticleTitleWrapperThemeProps>(componentConfigurationKey);
  const { showOnlyDate } = themeProps;
  const createdAtTimestamp = showOnlyDate ? createdAtDate : createdAt;
  const updatedAtTimestamp = showOnlyDate ? updatedAtDate : updatedAt;
  return (
    <ArticleTitle
      title={title}
      by={by}
      updatedText={updatedText}
      createdAt={createdAtTimestamp}
      createdAtISO={createdAtISO}
      updatedAt={updatedAtTimestamp}
      updatedAtISO={updatedAtISO}
      showUpdatedAt={showUpdatedAt}
      authors={authors}
    >
      {children}
    </ArticleTitle>
  );
};
